/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CashInputs */

const cs_enum_cash = /** @type {(inputs: Enum_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotovost`)
};

const en_enum_cash = /** @type {(inputs: Enum_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cash`)
};

/**
* | output |
* | --- |
* | "Cash" |
*
* @param {Enum_CashInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_cash = /** @type {((inputs?: Enum_CashInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CashInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_cash(inputs)
	return cs_enum_cash(inputs)
});